import { render, staticRenderFns } from "./ListAppointments.vue?vue&type=template&id=76d8ffbe&scoped=true"
import script from "./ListAppointments.vue?vue&type=script&lang=js"
export * from "./ListAppointments.vue?vue&type=script&lang=js"
import style0 from "./ListAppointments.vue?vue&type=style&index=0&id=76d8ffbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d8ffbe",
  null
  
)

export default component.exports